module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="nei-banner">\r\n    <img src="' +
((__t = ( require('./images/news-banner.jpg') )) == null ? '' : __t) +
'" />\r\n    <div class="title">新闻动态</div>\r\n</div>';

}
return __p
}